import { DataGrid,  useGridApiRef } from '@mui/x-data-grid';
import { Box, Button, Container, Typography, useMediaQuery, TextField, DialogActions} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useCallback, useContext, useEffect, useState } from 'react';
import {PrintOutlined, SystemUpdateAltOutlined ,InfoOutline,Verified, CheckCircleOutline} from '@mui/icons-material';
import DialogBox from '../ajax/DialogBox'
import { toast } from 'react-toastify';
import { Chip } from "@mui/material";
import { MenuItem } from '@mui/material';
import { callPostApi } from '../../function/ApiCallFunction';
import GradientLoader from '../CommanComponents/GradientLoader';
import LoadQRCode from './LoadQRCode';
import { DataContext } from '../../context/DataContext';

export default function LoadnActiveQR() 
{
    const navigate = useNavigate();
    const {loginData,setLoginData } = useContext(DataContext);
    const store_id = loginData?.store_info?.store_id;

  const [loading, setLoading] = useState(false);
  
  const apiRef = useGridApiRef();
  const isMobile = useMediaQuery('(max-width:768px)');
  const [loadedNo, setLoadedNo] = useState('');
  const [amount, setAmount] = useState('');
  const [errors, setErrors] = useState({});
  const [open, setOpen] = useState(false);
  const [datar, setDatar] = useState([]);
  const [selectionModel, setSelectionModel] =useState(['']); 
  const [filterLimit, setFilterLimit] = useState(100);
  const [filterStatus, setFilterStatus] = useState('RESERVE');
  const [filterLotNo, setFilterLotNo] = useState('');
  const [filterLoadedNo, setFilterLoadedNo] = useState('');

 // Validations for Load QR
  const validate = () => {
    const newErrors = {};
    if (!amount || isNaN(amount) || Number(amount) <= 0) { newErrors.amount= 'Enter a valid Amount'; }
    if (!loadedNo || isNaN(loadedNo) || Number(loadedNo) <= 0) { newErrors.loadedNo= 'Enter a valid Amount'; }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  //API to load QR
   const loadqrapi= async (selectedArray ) => {
      try {
        setLoading(true);
        const payload = { mod: "LOAD_CASHI_QECODE", data_arr: { store_id, amount:amount, loading_number:loadedNo, 
          tagLotId:selectedArray} };
        const apiResult = await callPostApi("cashi-qrcode", payload);
        if (apiResult.status === "200") {
          setOpen(false);
          setLoadedNo("");
          refreshPage();
          QRListApi('Pending', '', '', '100' );
        } else { toast.info(apiResult.status_message); }
      } catch (err) { } 
      finally { setLoading(false); }
    }; 

  //API for QR list
    const QRListApi= useCallback(async (status, lotno, loadedno, limit) => {
      try {
        setLoading(true);
        let qrstatus = "";
          if (status === "RESERVE") {  qrstatus = "RESERVE"; } else if (status === "Activated") { qrstatus = "2";
          } else if (status === "Loaded") { qrstatus = "1"; } else { qrstatus = ""; }
        const payload = { mod: "CASHI_QECODE_LIST",  data_arr: { store_id, genLotNumber: lotno, loadingNumber:loadedno,
            qrcodeStatus:qrstatus, start: '0', limit:filterLimit,},};
            
        const apiResult = await callPostApi("cashi-qrcode", payload);
        if (apiResult.status === "200" && Array.isArray(apiResult.data)) {
         const formattedData = apiResult.data.filter((item) => item.redeem_status === "0").map((item, index) => ({
          id:item.id,
          sr: index + 1,
          lotno: item.gen_lot_number || "NA",
          qr: item.qrcode_number || "NA",
          expdate: qrstatus === '0'
                 ?  item.date_added
                 : qrstatus === '1'
                 ?  item.loading_date
                 :  qrstatus ==='2'
                 ? item.active_date
                 : "NA",
          amount: item.amount || "0",
          loadedno: item.loading_number || "0",
           statuss: item.qrcode_status_name || "NA",
          status:
              item.qrcode_status === "0"
                ? "Pending"
                : item.qrcode_status === "2"
                ? "Activated"
                : item.qrcode_status === "1"
                ? "Loaded"
                : "NA" 
        }));
            setDatar(formattedData); 
        } else {
         setDatar([]);    
        }
      } catch (err) { 
      } finally {
        setLoading(false);
      }
    },[store_id,filterLimit]); 


   const clearFun = async () => {
       const newStatus = 'RESERVE';
         const newLotNo = "";
         const newLoadedNo = "";
         const newlimit = 100;
          setFilterStatus(newStatus);
          setFilterLimit(newlimit);
          setFilterLotNo(newLotNo);
          setFilterLoadedNo(newLoadedNo);
          await QRListApi(newStatus, newLotNo, newLoadedNo, newlimit);
    }

  useEffect(() => 
  {
    if (isMobile && apiRef.current) {
      apiRef.current.autosizeColumns({ includeHeaders: true });
    }

    QRListApi(filterStatus, filterLotNo, filterLoadedNo, filterLimit);
  }, [isMobile, filterStatus, filterLotNo, filterLoadedNo, filterLimit, QRListApi,apiRef]);
 

 //Refresh store amount
   const refreshPage = async (e) => 
   {
      try 
      {
          const payload = { mod: "STORE_DETAIL", data_arr: { store_id, }, };
          const apiResult = await callPostApi("store-login", payload);
          if (apiResult.status === "200" && apiResult.data) 
          {
              setLoginData(prev => 
              {
                  const updated = {...prev, store_info: apiResult.data.store_info };
                  sessionStorage.setItem('loginData', JSON.stringify(updated));
                  return updated;
              });

              window.dispatchEvent(new Event('refreshNavbar'));
          } 
          else { }
      } 
      catch (error) {} 
    };
 
 const columns = [
  { field: 'sr', headerName: 'Sr no.', flex: isMobile ? undefined : 0.5},
  { field: 'qr', headerName: 'QR',  flex: isMobile ? undefined : 1,}, 
  { field: 'amount', headerName: 'Amount', flex: isMobile ? undefined : 1 },
  { field: 'status', headerName: 'Status', flex: isMobile ? undefined : 1,
    renderCell: (params) => {
      let color = "default";
      let icon = null;
      let border = "default";

      switch (params.value) {
        case "Activated":
          color = "#098665";
          border= '1px solid #098665';
          icon = <Verified sx={{ fontSize: 18 }} />;
          break;
        case "Pending":
          color = "#e9aa0aff";
          border= '1px solid #e9aa0aff';
          icon = <InfoOutline sx={{ fontSize: 18 }} />;
          break;
        case "Loaded":
           color = "#0a32d4ff";
          border= '1px solid #0a32d4ff';
          icon = <CheckCircleOutline sx={{ fontSize: 18 }} />;
          break;
        default:
          color = "default";
      }
        return (
        <Chip
          icon={icon}
          label={params.value || "Unknown"}
          variant="outlined"
          color={color}
          sx={{ borderRadius: "18px", fontWeight: 500, border:{border}, color:{color} }}
        />
      );
    }
   },
  { field: 'lotno', headerName: 'Lot Number', flex: isMobile ? undefined : 1 },
  { field: 'loadedno', headerName: 'Loading Number', flex: isMobile ? undefined : 1 },
  { field: 'expdate', headerName: 'Date', flex: isMobile ? undefined : 1 }, 
 ]

 const handleActivateSuccess = useCallback(async () => {
  setFilterStatus('Pending');
  setFilterLotNo('');
  setFilterLoadedNo('');
  setFilterLimit(100);
  await QRListApi('Pending', '', '', '100');
 }, [QRListApi]);

 const opendataaload = () => {
  if (!apiRef.current) {  toast.error("Grid not initialized"); return; }
  const selectedIds = Array.from(apiRef.current.getSelectedRows().keys());
  if (selectedIds.length === 0) { toast.info("Please Select any QR from list!");
  } else { setOpen(true); }}

 const handleOk = () => {
   if (!apiRef.current) { toast.error("Grid not initialized"); return; }
    const selectedArray = Array.from(apiRef.current.getSelectedRows().keys());
   if (!validate()) return;   loadqrapi(selectedArray); }

 useEffect(() => {                    
  if (!open) {
    setAmount('')
    setErrors({});
  }  
}, [open]);

  return (
    <Container maxWidth="xl" sx={{ my: 2 }}>
      
      <Box sx={{ display: 'flex', justifyContent: 'start', mb: 2 }}>
        <Button variant="contained" sx={{ backgroundColor: '#000000', color: '#ffffff' }}
          onClick={() => navigate(-1)} >  Back </Button>
      </Box>

      <Typography   variant="h6" gutterBottom sx={{ background: 'linear-gradient(195deg, #49a3f1, #1A73E8)',
          p: 1,  color: '#ffffff', borderRadius: '4px', mb: 3, display: 'flex', alignItems: 'center'}}  >
        <SystemUpdateAltOutlined sx={{mx:1, fontSize:'22px'}}/>  
        QR Coupon List
      </Typography>

       <Box sx={{ display: 'flex', justifyContent: 'end', mb: 2 }}>
         <Button variant="contained"  sx={{ background:'linear-gradient(195deg, #42424a, #191919)', 
          color: '#ffffff'}} onClick={() => navigate('/dashboardPlus/printQR')} >
          <PrintOutlined sx={{mx:1}}/> Print QR
        </Button>
       
       {/* Load Button */}
       {filterStatus === "Pending" ?   <Button variant="contained" sx={{ background:'linear-gradient(195deg, #49a3f1, #1A73E8)', color: '#ffffff',ml:1}}
          onClick={() =>{opendataaload();} } >
          <SystemUpdateAltOutlined sx={{mx:1, fontSize:'22px'}}/> Load
         </Button> : " "}

        {/* Active Button */}
        {filterStatus === "Loaded" ? <LoadQRCode idsss={selectionModel} apiRef={apiRef}  onSuccess={handleActivateSuccess} /> : ""}
          
       </Box>
     
        {/* Filter section work */}
        <Box sx={{ display: 'flex',flexWrap:'wrap', gap: 2, mb: 2 }}>
        <TextField select label="Filter Status" value={filterStatus} onChange={e => { setFilterStatus(e.target.value);}} sx={{ minWidth: 140 }} >
            <MenuItem value="RESERVE">All</MenuItem>
            {/* <MenuItem value="Pending">Pending</MenuItem> */}
            <MenuItem value="Loaded">Loaded</MenuItem>
            <MenuItem value="Activated">Activated</MenuItem>
        </TextField>
        <TextField type='text' label="Lot Number" value={filterLotNo} onChange={e => setFilterLotNo(e.target.value)} sx={{ minWidth: 140 }} >
        </TextField>
        <TextField type='text' label="Loading Number" value={filterLoadedNo} onChange={e => setFilterLoadedNo(e.target.value)}
          sx={{ minWidth: 140 }} />
        <TextField select label="Limit" value={filterLimit} onChange={e => { setFilterLimit(e.target.value);}} sx={{ minWidth: 140 }} >     
            <MenuItem value={100}>100</MenuItem>
            <MenuItem value={300}>300</MenuItem>
            <MenuItem value={500}>500</MenuItem>
            <MenuItem value={2000}>All</MenuItem>
        </TextField>

        <Button variant="outlined" color="primary" sx={{ height: 56 }}
          onClick={() => { QRListApi(filterStatus, filterLotNo, filterLoadedNo,filterLimit); }} > Apply Filter </Button>
        <Button variant="outlined" color="error" sx={{ height: 56 }} onClick={() => { clearFun() }} > Clear Filter </Button>
      </Box>

      {/* DataGrid */}
      <Box sx={{ height: 'auto', width: '100%', mb: 4 }}>
        <DataGrid  apiRef={apiRef} rows={datar} columns={columns}
          initialState={{ pagination: { paginationModel: { pageSize: 10 },}, }} pageSizeOptions={[10, 25, 50]}
          showToolbar checkboxSelection
          selectionModel={selectionModel}
          onRowSelectionModelChange={(newRowSelectionModel) => { setSelectionModel(newRowSelectionModel); }}
          sx={{
             '& .MuiDataGrid-cell': {
               whiteSpace: 'normal',     // Allow wrapping
               lineHeight:'20px',
               wordBreak: 'break-word', 
               display: 'flex',
              alignItems: 'center', // Vertically center content
              gap: '4px'},
            '& .MuiDataGrid-columnHeaders': {
              backgroundColor: '#f0f0f0',
              color: '#000',
              fontWeight: 'bold',
            },
            '& .MuiDataGrid-columnHeaderTitle': {
              fontSize: 14,
              fontWeight: '600',
               whiteSpace: 'normal',
              wordBreak: 'break-word'
            },
          }}
         />
      </Box>

       <DialogBox open={open} onClose={() => setOpen(false)} title="Load QR Code">
          <TextField className="transparent-textfield" fullWidth margin="normal" label="Loading No." required  value={loadedNo}  
             onChange={(e) => { const value = e.target.value; setErrors(prev => ({ ...prev, loadedNo: undefined }));
              if (/^\d{0,5}$/.test(value)) { setLoadedNo(value); setErrors((prev) => ({ ...prev, loadedNo: undefined }));} }}
              error={!!errors.loadedNo} helperText={errors.loadedNo} type="number" inputprops={{ min: 1 }}/>

          <TextField className="transparent-textfield" fullWidth margin="normal" label="Enter Amount" required  value={amount}  
             onChange={(e) =>  { setAmount(e.target.value); setErrors(prev => ({ ...prev, amount: undefined }));}}
             error={!!errors.amount} helperText={errors.amount} type="number" inputprops={{ min: 1 }}/>
       <DialogActions>
           <Button onClick={() => setOpen(false)} color="primary"> Cancel </Button>
           <Button onClick={() => {handleOk()}} color="primary" variant="contained"> Ok </Button>
       </DialogActions>
      </DialogBox>

    {loading && <GradientLoader text="Loading" />} 
    </Container>
  );
}
